// @flow

import invariant                      from 'invariant';
import {
  put,
  select,
  takeEvery,
}                                     from 'redux-saga/effects';
import addPathToRouterHistory         from '../../actions/router/addPathToRouterHistory';
import removePathFromRouterHistory    from '../../actions/router/removePathFromRouterHistory';
import replacePathInRouterHistory     from '../../actions/router/replacePathInRouterHistory';
import type { LocationChangedAction } from '../../modules/connected-react-router/types';
import type { LocationRecord }        from '../../modules/react-router/domain/react-router.domain';
import { makeLocation }               from '../../modules/react-router/domain/react-router.domain';
import {
  selectCurrentLocation,
  selectPreviousLocation,
}                                     from '../../selectors/routerHistory';

// @todo $FlowFixMe
function* watchForUrlPathChanges() {

  // @todo $FlowFixMe
  yield takeEvery('@@router/LOCATION_CHANGE', checkForPathChange);

}


function* checkForPathChange(action: LocationChangedAction) {

  const historyAction = action.payload.action;

  const location: LocationRecord = makeLocation(action.payload.location);

  const currentLocation: ?LocationRecord = yield select(selectCurrentLocation);

  // Always add the first action, regardless of action, as for some reason it uses `POP` rather than `PUSH`
  if (!currentLocation) {
    yield put(addPathToRouterHistory({location}));
    return;
  }

  switch (historyAction) {
    case 'PUSH':
      if (currentLocation.pathname !== location.pathname) {
        yield put(addPathToRouterHistory({location}));
      } else {
        yield put(replacePathInRouterHistory({location}));
      }
      return;

    case 'POP':
      const previousLocation: ?Location = yield select(selectPreviousLocation);
      if (!previousLocation) {
        yield put(replacePathInRouterHistory({location}));
      } else {
        yield put(removePathFromRouterHistory());
      }
      return;

    case 'REPLACE':
      yield put(replacePathInRouterHistory({location}));
      return;

    default:
      invariant(false, `Don't know how to handle ${historyAction} actions`);
  }

}


export default watchForUrlPathChanges;


// WEBPACK FOOTER //
// ./src/sagas/router/watchForUrlPathChanges.js